import { ReactNode, FC } from 'react';
import Paper from 'components/atoms/Paper';

interface TabTemplateProps {
  children: ReactNode;
}

const TabTemplate: FC<TabTemplateProps> = ({ children }) => {
  return <Paper>{children}</Paper>;
};

export default TabTemplate;
